module.exports = __webpack_public_path__ + "static/screen-5250e150745b0c381ce50bf8757f8329.png";